<h2 mat-dialog-title>Edit User</h2>
<form [formGroup]="userForm">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-6">
        <div class="themeinput">
          <label>First Name</label>
          <input type="text" class="form-control" placeholder="First Name" formControlName="first_name" maxlength="30"
            [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="themeinput">
          <label>Last Name</label>
          <input type="text" class="form-control" placeholder="Last Name" formControlName="last_name" maxlength="30"
            [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="themeinput">
          <label>Email</label>
          <input type="email" class="form-control" placeholder="Email" formControlName="email" maxlength="50"
            [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="themeinput">
          <label>Mobile</label>
          <input type="text" class="form-control" placeholder="Mobile" formControlName="mobile" maxlength="10"
            (keypress)="keyPress($event)" [ngClass]="{ 'is-invalid': submitted && f['mobile'].errors }" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="themeinput">
          <label>Role</label><span style="color: red; font-size :15px">&nbsp;*</span>
          <select class="form-control" formControlName="role_id"
            [ngClass]="{ 'is-invalid': submitted && f['role_id'].errors }" [disabled]="true">
            <option value disabled selected>--Select Role--</option>
            <option *ngFor="let roleData of roleValue" [value]="roleData.id">{{ roleData.role }}</option>
          </select>
          <div *ngIf="submitted && f['role_id'].errors" class="invalid-feedback">
            <div *ngIf="f['role_id'].errors['required']">Role is required</div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="selectedRoleId === 3">
        <label>Outlet</label>
        <span style="color: red; font-size: 15px;">&nbsp;*</span>
        <!-- <select formControlName="outlet_id" class="form-select outlet-select"
          [attr.value]="userForm.get('outlet_id')?.value"
          [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }" (change)="onOutletChange($event)">
          <option value="" disabled selected>--Select
            Outlet--</option>
          <option *ngFor="let outletData of prodOut" [value]="outletData.id" [disabled]="outletData.disable">{{
            outletData.outlet_name }} - {{outletData.outlet_code}}</option>
        </select> -->
        <ng-multiselect-dropdown [placeholder]="'Select Outlet'" formControlName="outlet_id" class="form-control"
          [settings]="outletSetting" [data]="prodOut" [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }">
        </ng-multiselect-dropdown>
        <div class="invalid-feedback" *ngIf="submitted && f['outlet_id'].errors">
          <div *ngIf="f['outlet_id'].errors['required']">Outlet
            is required</div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="selectedRoleId === 3">
        <div class="themeinput">
          <label>Category</label><span style="color: red; font-size:15px">&nbsp;*</span>
          <div class="multiselect-wrapper">
            <ng-multiselect-dropdown [placeholder]="'--Select Product Category--'" [settings]="dropdownSettings"
              [data]="filteredProdCat" formControlName="product_category" (onSelect)="onCategorySelect($event)"
              (onDeSelect)="onCategoryDeSelect($event)"
              [ngClass]="{ 'is-invalid': submitted && f['product_category'].errors }">
            </ng-multiselect-dropdown>
          </div>
          <div class="invalid-feedback" *ngIf="submitted && f['product_category'].errors">
            <div *ngIf="f['product_category'].errors['required']">Product Category is required</div>
          </div>
        </div>
      </div>
      <div *ngIf="isRegionRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
        <label>Region</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
        <ng-multiselect-dropdown [placeholder]="'Select Region'" formControlName="region_id" class="form-control"
          [settings]="dropdownSettingsRegion" [data]="regionValue"
          [ngClass]="{ 'is-invalid': submitted && f['region_id'].errors }">
        </ng-multiselect-dropdown>

        <div class="invalid-feedback" *ngIf="submitted && f['region_id'].errors">
          <div *ngIf="f['region_id'].errors['required']">Region is required</div>
        </div>
      </div>
      <div *ngIf="isAreaRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
        <label>Area</label>
        <span style="color: red; font-size: 15px;">&nbsp;*</span>
        <ng-multiselect-dropdown [placeholder]="'Select Area'" formControlName="area_id" class="form-control"
          [settings]="dropdownSettingsArea" [data]="areaValue"
          [ngClass]="{ 'is-invalid': submitted && f['area_id'].errors }">
        </ng-multiselect-dropdown>

        <div class="invalid-feedback" *ngIf="submitted && f['area_id'].errors">
          <div *ngIf="f['area_id'].errors['required']">Area is required</div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
        <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
        <select name="" class="form-select" formControlName="status"
          [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
          <option value="" disabled selected>--Select Status--</option>
          <option *ngFor="let data of statusList" [value]="data.id">{{ data.name }}</option>
        </select>
        <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
          <div *ngIf="f['status'].errors['required']">Status is required</div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mt-4" *ngIf="selectedRoleId === 3">
        <div class="form-check mt-3">
          <input type="checkbox" class="form-check-input large-checkbox" id="is_verified" formControlName="is_verified"
            style="border: 1px solid #030303; ">

          <label class="form-check-label" for="is_verified" style="color: #333;">
            I confirm that I have checked and verified the DSE information.
          </label>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="buttons">
    <button mat-flat-button color="warn" mat-dialog-close>Cancel</button>
    <button mat-flat-button class="saveButton" type="submit" (click)="onSubmit()">Save</button>
  </div>
</form>